import RecordCartItem from './RecordCartItem';
import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'RecordsShoppingCart',

  components: {
    ShButton,
    RecordCartItem,
  },

  computed: {
    shoppingCart() {
      return this.$store.getters['record/recordsCart'];
    },
    isWaitingToDownloadZipFile() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['record/getRecordsZip']);
    },
  },

  methods: {
    async getAllRecords() {
      const records = this.shoppingCart.map(elem => (elem._id));
      const response = await this.$store.dispatch('record/getRecordsZip', { records });

      if(typeof response.data === 'object' && "records" in response.data && response.data.records.includes('limit_reached') && response.code == 406){
      this.$message({
        message: "Maksymalna pojemność koszyka to 20 nagrań",
        type: "error"
      });
      } else {
        this.fileDownload(response);
      }
    },
    fileDownload(response) {
      const date = new Date();
      const element = document.createElement('a');
      element.setAttribute('href', response.data);
      element.setAttribute('download', `recordsZip_${date.getFullYear()}/${date.getMonth()}/${date.getDate()}.zip`);
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        element.dispatchEvent(event);
      } else {
        element.click();
      }
    },
    clearCart() {
      this.$store.commit('record/CLEAR_RECORDS_CART', []);
      this.$message({
        showClose: true,
        message: 'Koszyk został opróżniony',
        type: 'success',
      });
    },
  },
};
